import { useCallback, useEffect, useState } from 'react'

export const MAX_IMAGE_ATTEMPTS = 5
const RETRY_DELAY_MS = 500

export const useImageRetry = (resetKey: string | number) => {
  const [attempt, setAttempt] = useState(0)
  const [isError, setIsError] = useState(false)
  const [isReady, setIsReady] = useState(true)

  useEffect(() => {
    setAttempt(0)
    setIsError(false)
    setIsReady(true)
  }, [resetKey])

  useEffect(() => {
    if (attempt === 0) {
      return undefined
    }

    setIsReady(false)
    const timer = setTimeout(() => setIsReady(true), RETRY_DELAY_MS * attempt)

    return () => clearTimeout(timer)
  }, [attempt])

  const onLoadError = useCallback(() => {
    setAttempt(prev => {
      if (prev + 1 >= MAX_IMAGE_ATTEMPTS) {
        setIsError(true)
        return prev
      }

      return prev + 1
    })
  }, [])

  return { attempt, isError, isReady, onLoadError }
}
